export enum InventoryKardexTypeEnum {
  MOVEMENT = 1,
  LAST_MOVEMENT = 2,
}

export const InventoryKardexTypeOptions = [
  { label: 'Kardex de Movimientos', value: InventoryKardexTypeEnum.MOVEMENT },
  { label: 'Inventario a una fecha', value: InventoryKardexTypeEnum.LAST_MOVEMENT },
]
